<template>
  <div class="spinner"/>
</template>

<script>
export default {
  name: 'Spinner'
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Spinner.vue